import isFullArray from 'utils/predicates/array/isFullArray.util';

export const hasOverdueInvoices = (invoices) => {
  if (!isFullArray(invoices?.results)) return false;

  return invoices.results.some((inv) => inv?.should_pay);
};
